import * as Comp from './without-variants.styles.ts'

export const LogoWhithoutVariant = () => {
  return <Comp.Label>Logo indisponível nesta variação</Comp.Label>
}
